import React from 'react';
import { graphql } from 'gatsby';
import Container from '@atoms/Container';
import SvgSafeGatsbyImage from '@atoms/SvgSafeGatsbyImage';
import paddingDefault from '@utils/paddingDefault';
import apCaseOnlyTitleTags from '@utils/apCaseOnlyTitleTags';
import Link from "../primitives/link";
import { colors } from '../primitives/colors';

// not being used.
const PartnerLogos = ({ data }) => {
    const { heading, partners } = data ?? '';

    return (
        <section css={paddingDefault()}>
            <Container css={styles.container}>
                <h2 css={styles.partnerLogosHeading}>
                    {apCaseOnlyTitleTags(heading)}
                </h2>
                <ul css={styles.partnerLogosWrap}>
                    {partners?.length &&
                        partners.map(partner => {
                            const { link, logo } = partner
                            return (
                                <li css={styles.partnerLogosItem} key={link.title}>
                                    <Link to={link.href}>
                                        {logo?.url ? (
                                            <SvgSafeGatsbyImage css={styles.partnerLogo} image={logo} alt={logo.title} />
                                        ) : (
                                            'Missing Logo'
                                        )}
                                    </Link>
                                </li>
                            )
                        })}
                </ul>
            </Container>
        </section>
    );
};

const styles = {
    container: {
        "@media (min-width: 1024px)": {
            paddingLeft: "4rem", paddingRight: "4rem"
        }
    },
    partnerLogosHeading: {
        color: colors.grey700,
        "marginBottom": "3rem",
        "fontSize": "0.875rem",
        "lineHeight": "1.25rem",
        letterSpacing: "1.5px"
    },
    partnerLogosWrap: {
        display: "grid",
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        gap: "1.25rem",
        "@media (min-width: 1024px)": {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            height: "3.5rem"
        }
    },
    partnerLogosItem: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    partnerLogo: {
        transform: "scale(75%)",
        "@media (min-width: 1024px)": {
            transform: "scale(100%)",
            maxHeight: "100%",
        }
    }
};

export const query = graphql`
  fragment PartnerLogosData on CmsPageBuilderBlocks {
    partner_logos {
      heading
      partners {
        link {
          href
          title
        }
        logo {
          filename
          title
          url
          contentStackAsset
        }
      }
    }
  }
`;

export default PartnerLogos;
